<template>
  <div>
        <CCard>
          <CCardBody>
            <div class="row" style="padding-bottom: 10px">
              <div class="col-2">
               <CButton
                    style="
                      background: red;
                      font-family: 'Montserrat';
                      color: white;
                      font-weight: 400;
                      border-radius: 5px;
                      font-size:14px;

                    "
                    @click="opened"
                    >Current Orders</CButton
                  >
              </div>
               <div class="col-3">
               <CButton
                    style="
                      background: red;
                      font-family: 'Montserrat';
                      color: white;
                      font-weight: 400;
                      border-radius: 6px;
                      font-size:14px;
                    "
                    @click="closed"
                    >Completed Orders</CButton
                  >
              </div>
              <div class="col-3">
                <b-form-select v-model="selectedorders" @change="filterMember">
                  <b-form-select-option value="all">All</b-form-select-option>
                                    <b-form-select-option value="Order Placed"
                    >Order Placed</b-form-select-option
                  >
                      <b-form-select-option value="Payment Received">Payment Received</b-form-select-option>
                                        <b-form-select-option value="Order Accepted"
                    >Order Accepted</b-form-select-option
                  >

      <b-form-select-option value="Dispatched">Order ready for Dispatch</b-form-select-option>

                        <b-form-select-option value="Delivery on the way"
                    > Delivery on the Way</b-form-select-option
                  >

      <b-form-select-option value="Delivered">Order Delivered</b-form-select-option>
                  <b-form-select-option value="Canceled"
                    >Order Cancelled</b-form-select-option
                  >
                </b-form-select>
              </div>
               <div class="col-4">
                <b-form-input
                  id="filter-input"
                  v-model="filter"
                  type="search"
                  placeholder="Search"
                  style="border-radius: 3rem"
                ></b-form-input>
              </div>
            </div>

            <b-table
              class="myTable"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              show-empty
              sort-icon-left
              responsive="sm"
            >
             <template v-slot:cell(deliverType)="data" >
                        <td >
                          <p>{{data.item.deliverType}}</p>
                        </td>
         </template>
                      <template v-slot:cell(paymentType)="data" >
                        <td style="position:relative;left:2rem;">
                          <p>{{data.item.paymentType}}</p>
                        </td>
         </template>

                      <template v-slot:cell(status)="data" >
                        <td >
                          <p>{{data.item.status}}</p>
                        </td>
         </template>
                      <template #cell(show_details)="item" >
<td  style="position:relative;left:2rem;color:#FF0000;cursor:pointer">
  <i class="fa fa-eye" aria-hidden="true"                 @click="passorder(item)"
></i>

        
            </td>                      </template>
            </b-table>
            <div class="mat-table__bottom">
              <span style="margin-right: 20px; margin-bottom: 15px">
                <b-form-select
                  id="per-page-select"
                  v-model="perPage"
                  :options="pageOptions"
                  size="sm"
                ></b-form-select>
              </span>
              <span class="">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  pills
                ></b-pagination>
              </span>
            </div> 
            </CCardBody
        ></CCard>
      <!-- </CCardBody> -->
      <CModal title="Update Status"       color="success"
 :show.sync="myModal" size="sm">
        <p>Are you sure to update a Status?</p>
        <template #footer>
          <CButton @click="update()">Yes</CButton>
                    <CButton @click="redeem()">No</CButton>

        </template>
      </CModal>
    <!-- </CCard> -->

    <div></div>
  </div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.8.0/jszip.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.8.0/xlsx.js"></script>
<script>
import firebase from "firebase";
import SelectTable from "../tables/SelectTable";
import moment from "moment";

export default {
  name: "producttable",
  components: {},
  data: () => {
    return {
      selectedorders: "all",
      currentitem: {},
      chatid: "",
      myModal: false,
      key: "",
      name: "",
      collapseDuration: 0,
      details: [],
      userId: "",
      tranid: "",
      itemsvaluee: "",
      id: "",
      datavalue: "",
      updatedatavalue: "",
      options: ["update"],
      option1: ["Shipped", "Payment Recieved"],
      selected: [],
      selectedOption: "some value",
      items: [],
      symbol: localStorage.getItem("symbol"),
      itemdelete: null,
      checker: true,
      SelectTable,
      temp: [],
      time: "",
      filter: "",
      bimg: null,
      datavalue: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],

      json_data: [],
      fields: [
        {
          key: "orderNumber",
          label: "ID",
          sortable: true,
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
        },
        {
          key: "orderDate",
          label: "Date",
          sortable: true,
        },

        {
          key: "total",
          label: "Value",
          sortable: true,
        },
         {
          key: "deliverType",
          label: "Deliver",
          sortable: true,
        }, {
          key: "paymentType",
          label: "Payment",
          sortable: true,
        },
        {
          key: "status",
          sortable: true,
          label: "Status",
        },
          {
          key: "show_details",
          label: "Detail",
          sorter: false,
          filter: false,
        },
      ],

    
    };
  },
  computed: {},
  methods: {
    filterMember: function (evt) {
      console.log(evt);
      var val = evt;
      if (val == "all") {
        this.items = this.allitems;
      } else if (val == "Order Placed") {
        this.items = this.allitems.filter(function (e) {
          return e.status == val;
        });
      } else if (val == "Order Accepted") {
        this.items = this.allitems.filter(function (e) {
          return e.status == val;
        });
      } else if(val == "Payment Recieved"){
        this.items = this.allitems.filter(function (e) {
          return e.status == val;
        });
      }else if(val == "Dispatched"){
        this.items = this.allitems.filter(function (e) {
          return e.status == val;
        });
      }else if(val == "Delivery on the way"){
        this.items = this.allitems.filter(function (e) {
          return e.status == val;
        });
      }else if(val == "Delivered"){
        this.items = this.allitems.filter(function (e) {
          return e.status == val;
        });
      }
      else{
                this.items = this.allitems.filter(function (e) {
          return e.status == val;
        });

      }
    },
    models(item,status) {
      console.log(item,status)
      this.selected=status;
      this.tranid = item.docid;
      this.chatid = item.chatID;
      this.currentitem = item;
      this.myModal = true;
    },
    passorder(item) {
      console.log(item.item);
      this.$router.push({
        name: "vieworder",
        params: {
          docid: item.item.orderNumber,
          data:item.item
        },
      });
    },
    clickHandler(e) {},
    redeem(){
     this.items=[];
     this.getOrderList(); 
     this.myModal=false;
    },
    update() {
      const db = firebase.firestore();
      db.collection("orders").doc(this.tranid).update({
        status: this.selected,
      });
      this.chatentry();
      this.myModal=false;
    },
    chatentry() {
      let timestamp = Math.round(+new Date());
      const db = firebase.firestore();
      const auth = firebase.auth();
      const phone = auth.currentUser.phoneNumber;
      let ids = this.chatid.split("-");
      let toid = ids[0] == phone ? ids[1] : ids[0];
      let fromid = ids[0] == phone ? ids[0] : ids[1];
      db.collection("messages")
        .doc(this.chatid)
        .collection(this.chatid)
        .doc(timestamp.toString())
        .set({
          from: fromid,
          to: toid,
          notification: [toid],
          timestamp: timestamp,
          content: "Order updated",
          // content: "",
          orderID: this.currentitem.docid,
          status: this.selected,
          orderNumber: this.currentitem.orderNumber,
          type: 4,
        })
        .then(() => {
          this.myModal = false;
        });
    },
    toggleDetails(item) {
      this.$set(this.items[item.id], "_toggled", !item._toggled);
      this.collapseDuration = 300;
      this.$nextTick(() => {
        this.collapseDuration = 0;
      });
    },
    getOrderList() {
      const db = firebase.firestore();
      let temp = 0;
      let self = this;
      db.collection("orders")
        .orderBy("orderDate", "desc")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log(doc.data().orders[0].id);
            if (doc.data().orders) {
              if (doc.data().orders[0].id == firebase.auth().currentUser.uid) {
                this.datavalue = {
                  docid: doc.id,
                  orderDate: moment(
                    new Date(doc.data().orderDate.seconds * 1000)
                  ).format("DD-MM-YYYY HH:MM:A"),
                  paymentType: doc.data().paymentType,
                  deliverType:doc.data().deliveryType,
                  total: self.symbol + " " + doc.data().total,
                  address: doc.data().address.address,
                  phone: doc.data().address.phone,
                  status: doc.data().status,
                  name: doc.data().address.name,
                  transactionRef: doc.data().transactionRef,
                  orders: doc.data().orders,
                  prodtitle: doc.data().orders[0].title,
                  prodimage: doc.data().orders[0].imgUrl,
                  prodqty: doc.data().orders[0].qty,
                  prodprice: doc.data().orders[0].price,
                  length: doc.data().orders.length,
                  chatID: doc.data().chatID,
                  orderNumber: doc.data().orderNumber ?? "",
                  peyk_oid: doc.data().peyk_oid,
                  peyk_charge: doc.data().peyk_charge,
                  peyk_symbol: doc.data().peyk_symbol,
                };
                this.datavalue["id"] = temp;
                temp = temp + 1;
                this.items.push(this.datavalue);
                this.allitems = this.items;
                                  this.totalRows =this.items.length

                self.download();
              }
            }
          });
          console.log("over");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    opened(){
      this.items=[];
      const db = firebase.firestore();
      let temp = 0;
      let self = this;
      db.collection("orders")
       .where("StoreId", "==", firebase.auth().currentUser.uid)
        .where("status", "!=","Delivered" )
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
                this.datavalue = {
                  docid: doc.id,
                  orderDate: moment(
                    new Date(doc.data().orderDate.seconds * 1000)
                  ).format("DD-MM-YYYY HH:MM:A"),
                  paymentType: doc.data().paymentType,
                  total: self.symbol + " " + doc.data().total,
                  address: doc.data().address.address,
                  phone: doc.data().address.phone,
                  status: doc.data().status,
                  name: doc.data().address.name,
                  transactionRef: doc.data().transactionRef,
                  orders: doc.data().orders,
                  deliverType:doc.data().deliveryType,
                  paymentType:doc.data().paymentType,
                  prodtitle: doc.data().orders[0].title,
                  prodimage: doc.data().orders[0].imgUrl,
                  prodqty: doc.data().orders[0].qty,
                  prodprice: doc.data().orders[0].price,
                  length: doc.data().orders.length,
                  chatID: doc.data().chatID,
                  orderNumber: doc.data().orderNumber ?? "",
                  peyk_oid: doc.data().peyk_oid,
                  peyk_charge: doc.data().peyk_charge,
                  peyk_symbol: doc.data().peyk_symbol,
                };
                this.datavalue["id"] = temp;
                temp = temp + 1;
                this.items.push(this.datavalue);
                                  this.totalRows =this.items.length

                self.download();
          });
          console.log("over");
        })
        .catch((err) => {
          console.log(err);
        });





    },
        closed(){
          this.items=[];
      const db = firebase.firestore();
      let temp = 0;
      let self = this;
      db.collection("orders")
       .where("StoreId", "==", firebase.auth().currentUser.uid)
        .where("status", "==","Delivered" )
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
                this.datavalue = {
                  docid: doc.id,
                  orderDate: moment(
                    new Date(doc.data().orderDate.seconds * 1000)
                  ).format("DD-MM-YYYY HH:MM:A"),
                  deliverType:doc.data().deliveryType,
                  paymentType:doc.data().paymentType,
                  total: self.symbol + " " + doc.data().total,
                  address: doc.data().address.address,
                  phone: doc.data().address.phone,
                  status: doc.data().status,
                  name: doc.data().address.name,
                  transactionRef: doc.data().transactionRef,
                  orders: doc.data().orders,
                  prodtitle: doc.data().orders[0].title,
                  prodimage: doc.data().orders[0].imgUrl,
                  prodqty: doc.data().orders[0].qty,
                  prodprice: doc.data().orders[0].price,
                  length: doc.data().orders.length,
                  chatID: doc.data().chatID,
                  orderNumber: doc.data().orderNumber ?? "",
                  peyk_oid: doc.data().peyk_oid,
                  peyk_charge: doc.data().peyk_charge,
                  peyk_symbol: doc.data().peyk_symbol,
                };
                this.datavalue["id"] = temp;
                temp = temp + 1;
                this.items.push(this.datavalue);
                                  this.totalRows =this.items.length

                self.download();
          });
          console.log("over");
        })
        .catch((err) => {
          console.log(err);
        });





    },

    editOrder(item) {
      this.$router.push({
        name: "editproduct",
        params: {
          id: item.userid,
          data: item,
        },
      });
    },
    deleteOrder(item) {
      const db = firebase.firestore();
      db.collection("products")
        .doc(item.item.userid)
        .delete()
        .then(() => {
          this.$router.push("/productorder");
        });
    },
    viewOrder(item) {
      this.$router.push({
        name: "viewProduct",
        params: {
          id: item.id,
          data: item.item,
        },
      });
    },
    download() {
      this.json_data = [];
      let o_data = [];
      console.log(typeof this.items);
      for (var i in this.items) {
        var item = this.items[i];
        this.json_data.push({
          "Order ID": item.orderNumber,
          "Order Date": item.orderDate,
          "Payment Type": item.paymentType,
          Total: item.total,
          Status: item.status,
          Name: item.name,
          "Number of Items": item.length,
          Phone: item.phone,
          Address: item.address,
        });
        let temp = this.json_data[i];
        for (let d in item.orders) {
          let item1 = item.orders[d];
          let name = "Item" + d;
          temp["Item " + d] = item1.title;
          temp["Item Price " + d] = item1.price;
        }
        this.json_data[i] = temp;
      }
    },
  },
  getBadge(status) {
    switch (status) {
      case "Payment Recieved":
        return "success";
      case "Shipped":
        return "secondary";
      case "Pending":
        return "warning";

      default:
        "primary";
    }
  },
  created: function () {
    this.getOrderList();
  },
};
</script>
<style >
/* .headModify > table > thead > th {
  display: none;
}
input[type="file"] {
  display: none;
}
.custom-file-upload {
  background-color: #321fdb;
  border: 1px solid #ccc;
  display: inline-block;
  cursor: pointer;
  color: #fff;
  border: 0;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.25rem;
} */
.myTable thead {
  font-weight: 600;
  font-family:'Montserrat';
  font-size: 18px;
  color: #3B4859;
  }
  .custom-select-sm {
  font-family:'Montserrat';

  }
.myTable  td{
  color: #3B4859;
  font-family: 'Assistant';
  font-weight:500;
  font-size:14px;
}
.mat-table__bottom { 
    display: flex;
    align-items: center;
    justify-content:  flex-end;
}
.b-pagination-pills .page-item .page-link {
  color:#3B4859;
  border: transparent;
  font-family: 'Montserrat';
  font-size: 12px;
  font-weight: 400;

}
.page-item.active .page-link {
    font-family: 'Montserrat';
font-size: 12px;
  font-weight: 400;
  background: #ff0000;
  color:#fff;
  border:#ff0000
}
.table td{
  padding: 0;
    vertical-align:0;
    border-top: none;
    border-top-color: none;
}
</style>
